import { IDetailedBudgetCategory } from '../../interfaces/idetailed-budget-category';
import { ProjectType } from '../project-type';

export class DetailedBudgetCategoryBase {
  DetailedBudgetCategoryId: number;
  Description: string | null;
  ProjectTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ProjectType?: ProjectType;

  constructor(item?: IDetailedBudgetCategory) {
    if (item) {

      this.DetailedBudgetCategoryId = item.DetailedBudgetCategoryId;
      this.Description = item.Description;
      this.ProjectTypeId = item.ProjectTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}